"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_common_1 = require("@ryerson/frontend.common");

var CookieBanner = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: block;\n\twidth: 100%;\n\tposition: fixed;\n\tbottom: 0;\n\theight: auto;\n\tbox-sizing: border-box;\n\tz-index: ", ";\n\tpadding: 24px 0px;\n\t", "\n"])), frontend_common_1.IndexedLayers.modal, function (props) {
  var background = props.background,
      opacity = props.opacity,
      visible = props.visible;
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tbackground-color: ", ";\n\t\t\topacity: ", ";\n\t\t\tvisibility: ", ";\n\t\t\ttransition: ", ";\n\t\t"])), background, opacity, visible, opacity === 1 ? "opacity 0.5s linear 0.25s, visibility 0.5s linear 0.25s" : "opacity 0.5s linear, visibility 0.5s linear");
});
var CookieContent = {
  en: {
    text: "We use cookies and other tracking technologies, including session replay tools, to learn how you use the site in real-time, track and tailor your online experience, serve targeted marketing, and improve the website. By continuing to use this website, you agree to the use of these technologies by Ryerson and our third-party provider. To learn more about how we use cookies, please see our ",
    linkLabel: "Privacy Policy",
    link: "/privacy-policy",
    buttonLabel: "Accept"
  },
  fr: {
    text: "Nous utilisons des cookies et d'autres technologies de suivi, y compris des outils de relecture de session, pour apprendre comment vous utilisez le site en temps r\xE9el, suivre et personnaliser votre exp\xE9rience en ligne, servir du marketing cibl\xE9 et am\xE9liorer le site Web. En continuant \xE0 utiliser ce site Web, vous acceptez l'utilisation de ces technologies par Ryerson et notre fournisseur tiers. Pour en savoir plus sur la fa\xE7on dont nous utilisons les cookies, veuillez consulter notre ",
    linkLabel: "Politique de confidentialité",
    link: "/privacy-policy",
    buttonLabel: "Accepter"
  },
  es: {
    text: "Utilizamos cookies y otras tecnolog\xEDas de seguimiento, incluidas herramientas de reproducci\xF3n de sesiones, para aprender c\xF3mo utiliza el sitio en tiempo real, rastrear y adaptar su experiencia en l\xEDnea, servir marketing dirigido y mejorar el sitio web. Al continuar utilizando este sitio web, acepta el uso de estas tecnolog\xEDas por parte de Ryerson y nuestro proveedor de terceros. Para obtener m\xE1s informaci\xF3n sobre c\xF3mo usamos las cookies, consulte nuestra ",
    linkLabel: "Política de privacidad",
    link: "/privacy-policy",
    buttonLabel: "Aceptar"
  }
};

exports.default = function () {
  var _ref = (0, frontend_application_1.useApplication)(),
      language = _ref.localization.language;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      showCookieBanner = _react_1$default$useS2[0],
      setShowCookieBanner = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(false),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      renderCookieBanner = _react_1$default$useS4[0],
      setRenderCookieBanner = _react_1$default$useS4[1];

  react_1.default.useEffect(function () {
    if ((localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("acceptedCookies")) === null) {
      //User has not actively OR passively accepted cookies
      setShowCookieBanner(true);
      setRenderCookieBanner(true);
    }
  }, []);

  var acceptCookies = function acceptCookies() {
    setShowCookieBanner(false);
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("acceptedCookies", "true");
  };

  var handleTransitionEnd = function handleTransitionEnd(e) {
    var _a;

    ((_a = e.currentTarget.attributes.getNamedItem("opacity")) === null || _a === void 0 ? void 0 : _a.value) === "0" && setRenderCookieBanner(false);
  };

  if (!renderCookieBanner) return null;
  return (0, jsx_runtime_1.jsx)(CookieBanner, {
    background: theme.colors.primary.gray,
    opacity: showCookieBanner === true ? 1 : 0,
    onTransitionEnd: function onTransitionEnd(e) {
      handleTransitionEnd(e);
    },
    visible: showCookieBanner === true ? "visible" : "hidden",
    children: (0, jsx_runtime_1.jsx)(frontend_layout_1.ContentSection, {
      vPadding: "0px",
      type: "split",
      split: {
        splitDirection: "vertical",
        splitColors: [{
          color: theme.colors.primary.gray,
          percentage: "100%"
        }]
      },
      children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
            variant: "div",
            size: "md",
            color: theme.colors.primary.white,
            css: (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tline-height: 20px !important;\n\t\t\t\t\t\t\t"]))),
            children: [CookieContent[language].text, " ", (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
              to: CookieContent[language].link,
              gatsby: false,
              target: "_blank",
              color: theme.colors.primary.white,
              dataTestId: "cookie-privacy-policy-link",
              children: CookieContent[language].linkLabel
            }), "."]
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
            size: "sm",
            label: CookieContent[language].buttonLabel,
            onClick: acceptCookies,
            type: "secondary",
            dataTestId: "accept-cookie-button"
          })
        })]
      })
    })
  });
};